//=============================================================================
//                       <--- Developed By Icon Team --->
//=============================================================================

// custom pages
import config from "config/index";
import HandleApiResponse from "helpers/handleApiResponse";

const product = () => {
  const { handleResponse, handleError } = HandleApiResponse();



  async function getShiptoDetail(values) {
    try {
      const obj = {
        method: "POST",
        credentials: 'include',
        headers: {
          "Content-Type": "application/json"          
        },
        body: JSON.stringify(values),
      };
      let res = await fetch(`${config.host}/cdr-gep/upgrade-loyalty/get-details`, obj);
      return handleResponse(res);
    } catch (err) {
      handleError(err);
    }
  }

  async function getcreation(values) {
    try {
      const obj = {
        method: "POST",
        credentials: 'include',
        headers: {
          "Content-Type": "application/json"          
        },
        body: JSON.stringify(values),
      };
      let res = await fetch(`${config.host}/cdr-gep/upgrade-loyalty/create-thrive-signature`, obj);
      return handleResponse(res);
    } catch (err) {
      handleError(err);
    }
  }

  async function getLinks(values) {
    try {
      const obj = {
        method: "POST",
        credentials: 'include',
        headers: {
          "Content-Type": "application/json"          
        },
        body: JSON.stringify(values),
      };
      let res = await fetch(`${config.host}/cdr-gep/upgrade-loyalty/redirection-link`, obj);
      return handleResponse(res);
    } catch (err) {
      handleError(err);
    }
  }
  async function getsericepluscreation(values) {
    try {
      const obj = {
        method: "POST",
        credentials: 'include',
        headers: {
          "Content-Type": "application/json"          
        },
        body: JSON.stringify(values),
      };
      let res = await fetch(`${config.host}/cdr-gep/upgrade-loyalty/create-thrive-serviceplus`, obj);
      return handleResponse(res);
    } catch (err) {
      handleError(err);
    }
  }

 
  async function productExport(values) {
    try {
      const obj = {
        method: "POST",
        credentials: 'include',
        headers: {
          "Content-Type": "application/json"          
        },
        body: JSON.stringify(values),
      };
      let res = await fetch(`${config.host}/cdr-panel/product/export`, obj);
      return handleResponse(res);
    } catch (err) {
      handleError(err);
    }
  }

  async function getunlockedDetail(values) {
    try {
      const obj = {
        method: "POST",
        credentials: 'include',
        headers: {
          "Content-Type": "application/json"          
        },
        body: JSON.stringify(values),
      };
      let res = await fetch(`${config.host}/cdr-gep/upgrade-loyalty/get-unlock-details`, obj);
      return handleResponse(res);
    } catch (err) {
      handleError(err);
    }
  }


  async function getunlockedcreation(values) {
    try {
      const obj = {
        method: "POST",
        credentials: 'include',
        headers: {
          "Content-Type": "application/json"          
        },
        body: JSON.stringify(values),
      };
      let res = await fetch(`${config.host}/cdr-gep/upgrade-loyalty/create-thrive-unlocked`, obj);
      return handleResponse(res);
    } catch (err) {
      handleError(err);
    }
  }

  async function getsignatureDetail(values) {
    try {
      const obj = {
        method: "POST",
        credentials: 'include',
        headers: {
          "Content-Type": "application/json"          
        },
        body: JSON.stringify(values),
      };
      let res = await fetch(`${config.host}/cdr-gep/upgrade-loyalty/get-signature-details`, obj);
      return handleResponse(res);
    } catch (err) {
      handleError(err);
    }
  }

   async function getcreationlanding(values) {
    try {
      const obj = {
        method: "POST",
        credentials: 'include',
        headers: {
          "Content-Type": "application/json"          
        },
        body: JSON.stringify(values),
      };
      let res = await fetch(`${config.host}/cdr-gep/upgrade-loyalty/create-thrive-signature-landing`, obj);
      return handleResponse(res);
    } catch (err) {
      handleError(err);
    }
  }

 

  

  return {
    getShiptoDetail,
    productExport,
    getcreation,
    getsericepluscreation,
    getLinks,
    getunlockedDetail,
    getunlockedcreation,
    getsignatureDetail,
    getcreationlanding
  };
};

export default product;
